import React from 'react'

import Navbar from './components/navBar/Navbar'
import Routes from './Routes'

const App = () => {
  return (
    <div >
      <Navbar />
      <Routes />
    </div>
  )
}

export default App
